import {
  Box,
  Collapse,
  ListItem,
  ListItemIcon,
  Checkbox,
  Typography,
  Chip,
  CircularProgress,
  makeStyles,
} from "@material-ui/core";
import { useEffect, useState } from "react";
const UserListItem = ({
  disabled,
  name,
  rut,
  zones,
  contentListItemIcon,
  loading,
  children,
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClickItemIcon = () => {
    setOpen((prev) => !prev);
  };

  useEffect(() => {
    setOpen(false);
  }, [loading]);
  return (
    <ListItem
      disabled={disabled}
      role={undefined}
      dense
      style={{
        flexDirection: "column",
        alignItems: "stretch",
        position: "relative",
      }}
      data-id={open ? "open-expand" : "closed-expand"}
    >
      {loading && (
        <Box className={classes.loading}>
          <CircularProgress />
        </Box>
      )}
      <Box
        className=""
        style={{
          display: "flex",
          width: "100%",
          alignItems: "center",
        }}
      >
        {contentListItemIcon ? (
          <ListItemIcon
            style={{
              minWidth: "auto",
              pointerEvents: disabled ? "none" : "auto",
              opacity: disabled ? "0.6" : "1",
            }}
            onClick={handleClickItemIcon}
          >
            {contentListItemIcon}
          </ListItemIcon>
        ) : null}

        <Box
          style={{
            display: "flex",
            width: "100%",
            padding: 8,
            flexDirection: "column",
          }}
        >
          <Typography>{name}</Typography>
          <Typography variant="caption">{rut}</Typography>
          <Box display={"flex"} flexWrap={"wrap"}>
            {zones.map((z) => (
              <Chip
              size="small"
              variant="outlined"
                label={z.visitingZoneInfo.name}
                key={z.visitingZoneInfo._id}
              />
            ))}
          </Box>
        </Box>
      </Box>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </ListItem>
  );
};

export default UserListItem;

const useStyles = makeStyles((t) => ({
  loading: {
    display: "flex",
    position: "absolute",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    backdropFilter: "contrast(0.8) blur(0.5px)",
    zIndex: 3,
    left: 0,
    top: 0,
    borderRadius: t.spacing(2),
  },
}));
